module.exports = __webpack_public_path__ + "img/law3.a4095680.jpg";